<template>
  <v-navigation-drawer
    id="default-drawer"
    v-model="drawer"
    :dark="dark"
    :right="$vuetify.rtl"
    :src="drawerImage ? image : ''"
    :mini-variant.sync="mini"
    mini-variant-width="80"
    app
    width="260"
  >
    <template
      v-if="drawerImage"
      #img="props"
    >
      <v-img
        :key="image"
        :gradient="gradient"
        v-bind="props"
      />
    </template>

    <div class="px-2">
      <default-drawer-header />

      <v-divider class="mx-3 mb-2" />

      <default-list :items="menu" />
    </div>

    <!-- <template #append>
      <div class="pa-4 text-center">
        <app-btn
          class="text-none mb-4"
          color="white"
          href="https://vuetifyjs.com"
          small
          text
        >
          Documentation
        </app-btn>

        <app-btn
          block
          class="text-none"
          color="secondary"
          href="https://store.vuetifyjs.com/products/vuetify-material-dashboard-pro"
        >
          <v-icon left>
            mdi-package-up
          </v-icon>

          Upgrade to Pro
        </app-btn>
      </div>
    </template> -->

    <div class="pt-12" />
  </v-navigation-drawer>
</template>

<script>
  // Utilities
  import { get, sync } from 'vuex-pathify'
  import moment from 'moment'

  export default {
    name: 'DefaultDrawer',

    components: {
      DefaultDrawerHeader: () => import(
        /* webpackChunkName: "default-drawer-header" */
        './widgets/DrawerHeader'
      ),
      DefaultList: () => import(
        /* webpackChunkName: "default-list" */
        './List'
      ),
    },

    data: () => ({
      menu: [],
    }),

    computed: {
      ...get('user', [
        'dark',
        'gradient',
        'image',
        'info',
      ]),
      ...get('app', [
        'items',
        'version',
      ]),
      ...sync('app', [
        'drawer',
        'drawerImage',
        'mini',
      ]),
    },

    created () {
      // this.menu = this.items.filter(item => item.isAdmin === false)
    },

    async mounted () {
      this.menu = [
        ...this.items.filter(item => item.isAdmin !== true),
      ]

      await this.$http.get(`/api/v1/rooms/manager/${this.info.email}`).then(response => {
        this.myManageRooms = response.data

        if (this.myManageRooms.length < 1) {
          const index = this.menu.findIndex(menu => menu.isViewReserveManagers)

          this.menu.splice(index, 1)
        }
      }).catch(error => {
        console.log(error)
      })

      await this.$http.get(`/api/v1/managers/${this.info.email}`).then(response => {
        const managers = response.data
        const manager = managers[0]
        if (manager && moment(manager.endDtime) >= moment()) {
          const adminPages = this.items.filter(page => page.isAdmin === true && manager.selectedRole.includes(page.key))
          this.menu = this.menu.concat(adminPages)
        }
      }).catch(error => {
        console.log(error)
      })
    },
  }
</script>

<style lang="sass">
#default-drawer
  .v-list-item
    margin-bottom: 8px

  .v-list-item::before,
  .v-list-item::after
    display: none

  .v-list-group__header__prepend-icon,
  .v-list-item__icon
    margin-top: 12px
    margin-bottom: 12px
    margin-left: 4px

  &.v-navigation-drawer--mini-variant
    .v-list-item
      justify-content: flex-start !important
</style>
